import React, { Component } from "react";
import { DATA_TYPE, MAX_LENGTH } from "../../../../../constants/external-constants";
import { InputFieldFloatingLabel as InputField } from "../../../../common/custom-form/select-filter.component";

class Bouygues extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: null
        }
    }

    render() {

        return (
            <>
                <InputField
                    className="form-control"
                    type="text"
                    label={'Autres services & promotions – Autres services'}
                    value={this.props.autresServices}
                    fieldProp='invoiceUploadForm.autresServices'
                    maxLength={MAX_LENGTH.limit_255}
                    placeholder={'0.00'}
                    inputType={DATA_TYPE.decimal}
                    hasNegativeValue={true}
                    hasDecimalLimit={true}
                    decimalFormat={[24, 6]}
                />

            </>
        )
    }
}

export default Bouygues;